module.exports = __webpack_public_path__ + "static/media/01_video_thumbnail_desktop.d88ff461.jpg";